module.exports = "<div [ngSwitch]=\"view\" class=\"views\">\r\n    <fuse-chat-chats-sidenav class=\"view\"\r\n                             *ngSwitchCase=\"'chats'\"\r\n                             [@slideInRight]>\r\n    </fuse-chat-chats-sidenav>\r\n\r\n    <fuse-chat-user-sidenav class=\"view\"\r\n                            *ngSwitchCase=\"'user'\"\r\n                            [@slideInLeft]>\r\n    </fuse-chat-user-sidenav>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/chat/sidenavs/left/left.component.html
// module id = ./src/app/main/content/pages/chat/sidenavs/left/left.component.html
// module chunks = main